// Kits do jeito do cliente (18/10/2026, painel aprovado pelo Paulo: https://claude.ai/artifact/DYcsuozVPF4JMgkGB55SvB).
// Os substitutos que o robô usa quando falta um item do kit aparecem para o cliente escolher ("Monte do seu jeito").
// Ao trocar: a foto do kit se remonta com o item escolhido (a mesma montagem lineup das fotos dos kits, com os recortes
// do metacampo konvem.foto_kit), o preço muda (soma dos itens com o desconto do kit, terminando em ,90; "de" = soma) e
// a lista "O kit leva" acompanha. No Adicionar, a montagem diferente da que está no kit vira uma versão do kit criada
// na hora pelo robô (konvem-sync-disponibilidade, POST /kit/montar), para o pedido chegar com os itens certos.
// Dados: snippets/kv-kit-escolha (konvem.escolhas, gravado pelo robô com preço e situação de agora). O konvem.js chama
// window.kvKit.precos e window.kvKit.montar; no Noite de Hot Dog o refrigerante vem da etapa Bebida (kv-etapas).
const URL_MONTAR = 'https://konvem-sync-disponibilidade.pauloteixeira.workers.dev/kit/montar';
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const arred = (x) => { x = Math.round(x * 100) / 100; let v = Math.floor(x) + 0.9; if (v > x + 0.005) v -= 1; return Math.round(v * 100) / 100; };
const brl = (v) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
const curto = (n) => n.replace(/^(Pipoca para Microondas|Chocolate|Vinho Tinto Seco|Sorvete Kibon Pote|Caixa de Chocolate|Água Mineral|Espetinho de|Espetinho)\s+/i, '');
const estados = new WeakMap();

// opção = [nº da variante, nome, multiplicador, preço, à venda]
const aVenda = (s) => s.o.filter((o) => o[4] === 1);
const escolhe = (s) => s.cliente !== false && aVenda(s).length > 1;
const padrao = (v) => v.slots.map((s) => (aVenda(s)[0] ? aVenda(s)[0][0] : null));
const opcao = (s, n) => s.o.find((o) => o[0] === n);
const iguais = (a, b) => a.every((x, i) => x === b[i]);
function conta(v, escolha) {
  let soma = 0;
  v.slots.forEach((s, i) => { const o = escolha[i] != null && opcao(s, escolha[i]); if (o) soma += s.q * o[2] * o[3]; });
  soma = Math.round(soma * 100) / 100;
  return { soma, preco: arred(soma * (1 - v.desconto)) };
}
function versaoDe(st, pdp) {
  const vr = pdp.kvVariante ? pdp.kvVariante() : null;
  return st.d.escolhas.versoes.find((v) => vr && v.id === vr.id) || null;
}

// A foto lineup (a mesma conta do categorias.html das fotos dos kits) com o item escolhido no lugar do item do molde
function palco(st, v, escolha) {
  const m = st.d.foto && st.d.foto.moldes && st.d.foto.moldes[v.id];
  if (!m) return '';
  const rec = st.d.foto.recortes || {};
  const usados = new Set();
  const lista = m.itens.flatMap(([titulo, h, fil, rep]) => {
    let i = v.slots.findIndex((s, j) => !usados.has(j) && s.o[0][1] === titulo);
    if (i < 0) i = v.slots.findIndex((s, j) => !usados.has(j) && s.o.some((o) => o[1] === titulo));
    if (i >= 0) usados.add(i);
    const o = i >= 0 && escolha[i] != null ? opcao(v.slots[i], escolha[i]) : null;
    if (i >= 0 && !o) return [];
    const nome = o ? o[1] : titulo;
    if (!rec[nome]) return [];
    const r = o && o[2] > 1 ? Math.min(3, Math.round(rep * o[2])) : rep;
    return Array.from({ length: r }, () => ({ h, fil, r: rec[nome][1], arq: rec[nome][0] }));
  });
  if (!lista.length) return '';
  const CHAO = 960, LARG = 980, sombras = [];
  const k = 820 / Math.max(...lista.map((p) => (p.fil === 't' ? p.h + 60 : p.h)));
  const fila = (fil, base, sob) => {
    const l = lista.filter((p) => p.fil === fil).map((p) => ({ ...p, h: p.h * k }));
    if (!l.length) return [];
    let ws = l.map((p) => p.h * p.r);
    let total = ws.reduce((a, b) => a + b, 0) - sob * ws.slice(1).reduce((a, b) => a + b, 0);
    const e = Math.min(1, LARG / total); ws = ws.map((w) => w * e); total *= e;
    let x = (1080 - total) / 2;
    return l.map((p, i) => { const w = ws[i], h = p.h * e, left = x; x += w - sob * (ws[i + 1] || 0);
      sombras.push({ left: left + w * 0.08, top: base - 18, w: w * 0.84 });
      return { ...p, left, top: base - h, w, h }; });
  };
  const todos = [...fila('t', CHAO - 60, 0.12), ...fila('f', CHAO, 0.10)];
  const topo = Math.min(...todos.map((e) => e.top)), dy = (1080 - (CHAO - topo)) / 2 - topo;
  return `<div class="kv-kit__palco" style="background:radial-gradient(circle at 50% 55%, #FFFFFF 0%, ${m.cor} 70%)">`
    + sombras.map((s) => `<div class="kv-kit__sombra" style="left:${s.left}px;top:${s.top + dy}px;width:${s.w}px"></div>`).join('')
    + todos.map((e) => `<div class="kv-kit__peca" style="left:${e.left.toFixed(1)}px;top:${(e.top + dy).toFixed(1)}px;width:${e.w.toFixed(1)}px;height:${e.h.toFixed(1)}px"><img src="${esc(e.arq)}?width=600" alt=""></div>`).join('')
    + '</div>';
}

function desenhar(pdp) {
  const st = estados.get(pdp);
  const v = versaoDe(st, pdp);
  const escolha = v ? st.esc[v.id] : null;
  const mudou = v && !iguais(escolha, padrao(v));

  // foto: só quando o cliente trocou algo (sem troca fica a foto do kit, a aprovada)
  const caixa = $('.kv-pdp__foto', pdp);
  if (caixa) {
    let cam = $('.kv-kit__foto', caixa);
    const html = mudou ? palco(st, v, escolha) : '';
    if (html) {
      if (!cam) { cam = document.createElement('div'); cam.className = 'kv-kit__foto'; cam.setAttribute('aria-hidden', 'true'); caixa.append(cam); }
      cam.innerHTML = html + '<span class="kv-kit__selo">Foto com a sua escolha</span>';
      escalar(caixa);
    } else if (cam) cam.remove();
  }

  // lista "O kit leva" da descrição
  const ul = $('.kv-pdp__desc ul', pdp);
  if (ul) {
    if (st.ulOriginal == null) st.ulOriginal = ul.innerHTML;
    ul.innerHTML = mudou ? v.slots.map((s, i) => { const o = escolha[i] != null && opcao(s, escolha[i]); return o ? `<li>${Math.round(s.q * o[2])}x ${esc(o[1])}</li>` : ''; }).join('') : st.ulOriginal;
  }

  // "Monte do seu jeito"
  if (!st.bloco) return;
  const lugares = v ? v.slots.map((s, i) => ({ s, i })).filter(({ s }) => escolhe(s)) : [];
  st.bloco.hidden = !lugares.length;
  if (!lugares.length) return;
  const agora = conta(v, escolha).preco;
  const base = padrao(v);
  st.bloco.innerHTML = '<div class="kv-kit__topo"><b>Monte do seu jeito</b><small>troque o que quiser</small></div>' + lugares.map(({ s, i }) => {
    const atual = opcao(s, escolha[i]);
    const trocado = escolha[i] !== base[i];
    return `<div class="kv-kit__lugar"><div class="kv-kit__nome">${Math.round(s.q * atual[2])}x ${esc(curto(atual[1]))}${trocado ? ' <em>trocado</em>' : ''}</div>`
      + `<div class="kv-kit__trilho" role="group" aria-label="Trocar ${esc(curto(s.o[0][1]))}">` + aVenda(s).map((o) => {
        const alt = escolha.slice(); alt[i] = o[0];
        const d = Math.round((conta(v, alt).preco - agora) * 100) / 100;
        const no = o[0] === escolha[i];
        const rec = st.d.foto && st.d.foto.recortes && st.d.foto.recortes[o[1]];
        const qx = o[2] !== 1 ? ` (${Math.round(s.q * o[2])}x)` : '';
        return `<button type="button" class="kv-kit__op" data-kv-kit-i="${i}" data-kv-kit-o="${o[0]}" aria-pressed="${no}">`
          + (rec ? `<img src="${esc(rec[0])}?width=160" alt="" loading="lazy" width="56" height="56">` : '<span class="kv-kit__sem"></span>')
          + `<span class="kv-kit__opn">${esc(curto(o[1]))}${qx}</span>`
          + `<span class="kv-kit__d${d > 0 ? ' kv-kit__d--mais' : d < 0 ? ' kv-kit__d--menos' : ''}">${no ? 'no kit' : d > 0 ? '+ ' + brl(d) : d < 0 ? '− ' + brl(-d) : 'mesmo preço'}</span></button>`;
      }).join('') + '</div></div>';
  }).join('');
}

function escalar(caixa) {
  const p = $('.kv-kit__palco', caixa);
  if (p) p.style.transform = `scale(${caixa.clientWidth / 1080})`;
}

function iniciar(pdp) {
  const dado = $('[data-kv-kit]', pdp);
  let d = null;
  try { d = JSON.parse(dado.textContent); } catch { return; }
  if (!d || !d.escolhas || !d.escolhas.versoes || !d.escolhas.versoes.length) return;
  const st = { d, esc: {}, bloco: $('[data-kv-kit-bloco]', pdp) };
  for (const v of d.escolhas.versoes) st.esc[v.id] = padrao(v);
  estados.set(pdp, st);
  if (st.bloco) st.bloco.addEventListener('click', (ev) => {
    const b = ev.target.closest('[data-kv-kit-o]');
    if (!b) return;
    const v = versaoDe(st, pdp);
    if (!v) return;
    st.esc[v.id][Number(b.dataset.kvKitI)] = Number(b.dataset.kvKitO);
    desenhar(pdp);
    if (pdp.kvRedesenhar) pdp.kvRedesenhar();
    const igual = $(`[data-kv-kit-i="${b.dataset.kvKitI}"][data-kv-kit-o="${b.dataset.kvKitO}"]`, st.bloco);
    if (igual) igual.focus({ preventScroll: true });
  });
  // Normal/Zero (e, no Hot Dog, o refrigerante da etapa Bebida)
  pdp.addEventListener('change', (ev) => {
    const r = ev.target.closest('input[data-kv-opcao]');
    if (!r) return;
    if (r.dataset.kvEscolha && st.esc[r.dataset.kvVersao]) st.esc[r.dataset.kvVersao][Number(r.dataset.kvSlot)] = Number(r.dataset.kvEscolha);
    desenhar(pdp);
    if (pdp.kvRedesenhar) pdp.kvRedesenhar();
  });
  for (const m of $$('[data-kv-miniatura]', pdp)) m.addEventListener('click', () => { const c = $('.kv-kit__foto', pdp); if (c) c.remove(); });
  const caixa = $('.kv-pdp__foto', pdp);
  if (caixa && 'ResizeObserver' in window) new ResizeObserver(() => escalar(caixa)).observe(caixa);
  desenhar(pdp);
  if (pdp.kvRedesenhar) pdp.kvRedesenhar();
}

window.kvKit = {
  // preço da montagem escolhida, no formato das variantes da loja (centavos); null = o da própria versão
  precos(pdp, variante) {
    const st = estados.get(pdp);
    if (!st || !variante) return null;
    const v = st.d.escolhas.versoes.find((x) => x.id === variante.id);
    if (!v || iguais(st.esc[v.id], padrao(v))) return null;
    const { soma, preco } = conta(v, st.esc[v.id]);
    return { price: Math.round(preco * 100), compare_at_price: Math.round(soma * 100) };
  },
  // a versão que vai para a cesta: a própria, ou a montada na hora pelo robô
  async montar(pdp, variante, botao) {
    const st = estados.get(pdp);
    const v = st && variante ? st.d.escolhas.versoes.find((x) => x.id === variante.id) : null;
    if (!v || iguais(st.esc[v.id], padrao(v))) return variante.id;
    if (botao) botao.textContent = 'Montando seu kit…';
    let r;
    try {
      r = await fetch(URL_MONTAR, { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ kit: st.d.kit, versao: v.id, escolha: st.esc[v.id] }), signal: AbortSignal.timeout(25000) });
    } catch { throw new Error('Não deu para montar o kit agora. Tente de novo.'); }
    const j = await r.json().catch(() => ({}));
    if (r.ok && j.id) return j.id;
    if (j.erro === 'acabou') throw new Error(`${j.item ? curto(j.item) : 'Um item que você escolheu'} acabou agora. Escolha outro.`);
    throw new Error('Não deu para montar o kit agora. Tente de novo.');
  },
};

for (const pdp of $$('[data-kv-pdp]')) if ($('[data-kv-kit]', pdp)) iniciar(pdp);
